<template>
  <main class="payment">
    <section class="section">
      <div class="row">
        <div class="row col-4 direction-column">
          <FormPaymentCard :item="payment" :disabled="true" :selected="true" />
          <FormPaymentPhysicalCard :disabled="true" :selected="true" />
        </div>
        <FormPaymentCreditCard class="col-8" @submit="programRegister" />
      </div>
    </section>

    <ProcessPayment v-show="loading"></ProcessPayment>
    <ModalError v-show="modalError">
      <p v-html="modalError"></p>
      <div class="row align-center">
        <Button class="button--option" @click.native="modalError = ''" type="button">
          Fechar
        </Button>
      </div>
    </ModalError>
  </main>
</template>

<script>
import FormPaymentCard from '@/components/forms/control/FormPaymentCard.vue';
import FormPaymentCreditCard from '@/components/forms/FormPaymentCreditCard.vue';
import FormPaymentPhysicalCard from '@/components/forms/control/FormPaymentPhysicalCard.vue';
import ProcessPayment from '@/components/modals/ProcessPayment.vue';
import ModalError from '@/components/modals/ModalError.vue';
import Register from '../../services/register';
import Payment from '../../services/payment';
import Button from '@/components/buttons/Button.vue';

const register = new Register();
const payment = new Payment();

export default {
  name: 'PaymentCreditCard',
  data() {
    return {
      payment: JSON.parse(sessionStorage.getItem('method')),
      items: JSON.parse(sessionStorage.getItem('register')),
      programId: this.$route.params.programId,
      token: null,
      data: null,
      clientId: sessionStorage.getItem('clientId'),
      installments: null,
      loading: false,
      modalError: ''
    };
  },
  components: {
    FormPaymentCard,
    FormPaymentCreditCard,
    FormPaymentPhysicalCard,
    ProcessPayment,
    ModalError,
    Button
  },
  methods: {
    programRegister(e) {
      const { parcels } = e;
      this.loading = true;
      this.$root.$emit('button-loading', true);
      this.installments = parcels;
      this.items.id = this.clientId;
      this.items.einstein = sessionStorage.einstein || 0;
      this.items.telemedicina_sharecare_individual =
        sessionStorage.telemedicina_sharecare_individual || 0;
      this.items.telemedicina_sharecare_familiar =
        sessionStorage.telemedicina_sharecare_familiar || 0;
      this.items.omt_sharecare = sessionStorage.omt_sharecare || 0;

      if (!this.clientId) {
        register
          .doRegister(this.programId, this.items)
          .then(res => {
            const { id } = res.data.data;
            this.clientId = id;
            sessionStorage.setItem('clientId', id);
            this.getIuguToken(e);
          })
          .catch(err => {
            const { message, code } = err.response.data.error;
            const data = {};

            if (code === 'email_duplicated' || code === 'customer_duplicated') {
              data.key = 'email';
              data.value = message;
            }

            this.$root.$emit('button-loading', false);
            this.loading = false;
            this.modalError = message;
            this.$router.push({
              name: 'register',
              query: data
            });
          });
      } else {
        this.getIuguToken(e);
      }
    },
    getIuguToken(e) {
      const { cardNumber, month, year, cvv } = e;
      const { Iugu } = window;
      const name = e.cardName.split(' ')[0];
      const lastName = e.cardName
        .split(' ')
        .splice(1)
        .join(' ');
      const cc = Iugu.CreditCard(cardNumber, month, year, name, lastName, cvv);

      Iugu.setAccountID(process.env.VUE_APP_IUGU_ACCOUNT_ID);
      Iugu.setTestMode(sessionStorage.getItem('env') !== 'production');

      const tokenResponseHandler = response => {
        const { id, errors } = response;
        if (errors) {
          this.$root.$emit('button-loading', false);
          this.loading = false;
          this.modalError =
            'Erro na geração do token de segurança. Tente novamente ou entre em contato com nossa central de atendimento.';
          return false;
        }

        this.token = id;
        this.cardName = e.cardName;
        this.cardCpf = e.cardCpf;
        return this.programPayment();
      };

      Iugu.createPaymentToken(cc, tokenResponseHandler);
    },
    programPayment() {
      const { method } = this.payment;
      const { items, token, installments, cardName, cardCpf } = this;
      this.data = items;
      this.data.id = this.clientId;
      this.data.type = method;
      this.data.token = token;
      this.data.installments = installments;
      this.data.cardName = cardName;
      this.data.cardCpf = cardCpf;
      this.data.einstein = sessionStorage.einstein || 0;
      this.items.telemedicina_sharecare_individual =
        sessionStorage.telemedicina_sharecare_individual || 0;
      this.items.telemedicina_sharecare_familiar =
        sessionStorage.telemedicina_sharecare_familiar || 0;
      this.data.omt_sharecare = sessionStorage.omt_sharecare || 0;
      this.data.renewal = sessionStorage.renewal === '1';
      this.data.dependents = sessionStorage.dependents || null;

      if (sessionStorage.utm_source) {
        this.data.utm_source = sessionStorage.utm_source;
      }

      if (sessionStorage.xtra) {
        this.data.xtra = sessionStorage.xtra;
      }

      payment
        .doPayment(this.programId, this.data)
        .then(res => {
          this.$root.$emit('button-loading', false);
          this.loading = false;
          sessionStorage.clear();
          sessionStorage.setItem('paid', res.data.message);
          this.$router.push({
            name: 'sucesso'
          });
        })
        .catch(err => {
          this.$root.$emit('button-loading', false);
          this.loading = false;
          this.modalError = err.response.data.error.message;
        });
    }
  }
};
</script>
